// Forwarding shared instance so we can update existing code as it makes sense.
export { default } from '@shared/api/util/axios.js'

// TODO: ENG-5403 - Add remaining "current client" endpoints
export const clientContext = {}
export function setClientContext (context) {
  Object.assign(clientContext, context)
}
export function resetClientContext () {
  Object.assign(clientContext, {
    getStyleProfileId: () => '',
    getUsername: () => ''
  })
}
resetClientContext()